import React, { useEffect } from 'react';
import { useTitle } from '../HooksPublic';
import { CDN_URL } from '../ConfigPublic';
import { Link } from 'react-router-dom';
import { Button } from 'react-frontier';
import { HeroVideo } from '../components';

import '../style/customized_business.scss';

var CustomizedBusiness = () => {
	var { setTitle } = useTitle();


	useEffect(() => {
		setTitle('Personalizados Empresariales | COCOAN', false);
	}, []);

	return (
		<main className='co customized-business-screen'>
			<header className='customized-business-hero'>
				<HeroVideo 
					className="hero-bg"
					srcMobile={`${CDN_URL}/static/business/BANNER_EMPRESARIALES_MOBILE.webm`}
					srcDesktop={`${CDN_URL}/static/business/BANNER_EMPRESARIALES_DESKTOP.webm`}
				/>
				<div className='hero-overlay'>
					<h1><span className="font-graphik">Personalizados</span><br /><span className="font-homemade-apple">Empresariales</span></h1>
				</div>
			</header>

			<section className="section-container">
				<article className="intro-section">
					<div className="text-content">
						<h2 className='font-graphik-light'>Lo mejor para <br /> tu <span className="font-graphik-bold">empresa</span></h2>
						<p className="subtitle font-graphik-light">
								Regalos corporativos personalizados que dejan huella. Conoce las opciones de chocolates personalizados que tenemos para ser parte de tus eventos corporativos.
						</p>
					</div>
					<figure className="image-content">
						<img src={`${CDN_URL}/static/business/EMPRESARIALES.webp`} alt="Chocolates personalizados COCOAN para empresas" />
					</figure>
				</article>
			</section>

			<section className="pillars-section-full">
				<div className="pillars-grid">
					<div className="pillar-card" style={{ backgroundImage: `url(${CDN_URL}/static/business/EMP1.webp)` }}>
						<div className="pillar-overlay">
							<h3 className="pillar-title font-graphik-light">Asesoría <br /> <span className="font-graphik-semibold">Personalizada</span></h3>
						</div>
					</div>
					<div className="pillar-card" style={{ backgroundImage: `url(${CDN_URL}/static/business/EMP2.webp)` }}>
						<div className="pillar-overlay">
							<h3 className="pillar-title font-graphik-light">Calidad <br /> <span className="font-graphik-semibold">Excepcional</span></h3>
						</div>
					</div>
					<div className="pillar-card" style={{ backgroundImage: `url(${CDN_URL}/static/business/EMP3.webp)` }}>
						<div className="pillar-overlay">
							<h3 className="pillar-title font-graphik-light">Personalización <br /> <span className="font-graphik-semibold">Absoluta</span></h3>
						</div>
					</div>
				</div>
			</section>

			<section className='section-request-quote'>
				<h2>Los mejores aliados para tus eventos</h2>
				<p>Contamos con expertiz y calidad en todos nuestros productos, te ayudamos a elegir el  que mejor se adecúe a tu evento y colaboradores, impactando desde el sabor hasta el empaque.</p>
				<a href={`https://wa.me/528129448353?text=${encodeURIComponent('¡Hola! Vengo de la página, me gustaría tener más información de personalizados.')}`} target='_blank' rel='noopener noreferrer' >
					<Button text='Quiero cotizar' size='big' />
				</a>
			</section>

			<section className="section-container products-section">
				<h2><span className="font-graphik-bold">Para cualquier</span> <span className="font-homemade-apple">evento</span></h2>
				
				<div className="bento-layout">
					{[
						{ title: "Eventos de PR", img: `${CDN_URL}/static/business/IMG_GRANDE_EMPRESARIAL.webp` },
						{ title: "Aperturas", img: `${CDN_URL}/static/business/IMG_CHICA2_EMPRESARIAL.webp` },
						{ title: "Eventos internos", img: `${CDN_URL}/static/business/ARTE_2.webp` },
						{ title: "Activaciones de marca", img: `${CDN_URL}/static/business/CHOCO_PERSO.webp` },
						{ title: "Personalizados empresariales", img: `${CDN_URL}/static/landing/PERSONALIZADO_EMPRESARIAL.webp` },
						{ title: "Eventos externos", img: `${CDN_URL}/static/business/IMG_GRANDE2_EMPRESARIAL.webp` }
					].map((item, idx) => (
						<article className={`bento-card bento-${idx + 1}`} key={idx}>
							<figure className="product-image">
								<img src={item.img} alt={item.title} />
							</figure>
							<div className="product-info-overlay">
								<h4 className="product-title">{item.title}</h4>
							</div>
						</article>
					))}
				</div>
			</section>

			<section className="companies-section">
				<h2 className="font-graphik-bold">Nuestros aliados</h2>
				<p className="section-subtitle font-graphik-light">Proyectos a la medida para grandes marcas</p>
				<div className="logos-marquee">
					<div className="marquee-track">
						<img src={`${CDN_URL}/static/business/AREMA_LOGO.webp`} alt="Arema Logo" />
						<img src={`${CDN_URL}/static/business/EMWA_LOGO.webp`} alt="Emwa Logo" />
						<img src={`${CDN_URL}/static/business/LEXUS_LOGO.webp`} alt="Lexus Logo" />
						<img src={`${CDN_URL}/static/business/TEC_LOGO.webp`} alt="Tec Logo" />
						
						<img src={`${CDN_URL}/static/business/AREMA_LOGO.webp`} alt="Arema Logo" />
						<img src={`${CDN_URL}/static/business/EMWA_LOGO.webp`} alt="Emwa Logo" />
						<img src={`${CDN_URL}/static/business/LEXUS_LOGO.webp`} alt="Lexus Logo" />
						<img src={`${CDN_URL}/static/business/TEC_LOGO.webp`} alt="Tec Logo" />
						
						<img src={`${CDN_URL}/static/business/AREMA_LOGO.webp`} alt="Arema Logo" />
						<img src={`${CDN_URL}/static/business/EMWA_LOGO.webp`} alt="Emwa Logo" />
						<img src={`${CDN_URL}/static/business/LEXUS_LOGO.webp`} alt="Lexus Logo" />
						<img src={`${CDN_URL}/static/business/TEC_LOGO.webp`} alt="Tec Logo" />
					</div>
				</div>
			</section>
		</main>
	);
};

export default CustomizedBusiness;
